import BaseAPI from 'api/api'
export interface FollowUpInterFace {
  page?: number
  pageLimit?: number
  search?: string
  branchId?: any
  dateStart?: any
  dateEnd?: any
  patientId?: number
}

export interface HistoryFollowUpInterFace {
  page?: number
  pageLimit?: number
  search?: string
  branchId?: any
  dateStart?: any
  dateEnd?: any
}

export interface MoveStageInterFace {
  stageNumberStart?: number
  stageNumberTo?: number
}

const url = `follow-up`


interface bodyCancelFollow {
  username: string,
  password: string,
  cancelRemark: string
}

export default class FollowUpApi extends BaseAPI {
  static clinicIncome(): Promise<any> {
    return this.api.get(`${url}/clinic-income`)
  }

  static listFollowUp(props: FollowUpInterFace): Promise<any> {
    return this.api.get(`${url}`, { params: { ...props } }).then((res) => res)
  }

  static historyFollowUp(props: HistoryFollowUpInterFace): Promise<any> {
    return this.api.get(`${url}/history`, { params: { ...props } }).then((res) => res)
  }

  static moveStage(followUpId: number, body: MoveStageInterFace) {
    return this.api.patch(`${url}/stage/${followUpId}`, body)
  }

  static findFollowUpId(followUpId: number): Promise<any> {
    return this.api.get(`${url}/${followUpId}`)
  }
  static findHistoryLogsId(params: any, followUpId: number): Promise<any> {
    return this.api.get(`${url}/history-logs/${followUpId}`, { params: { ...params } })
  }

  static findHistoryStageId(params: any, followUpId: number): Promise<any> {
    return this.api.get(`${url}/history-stage/${followUpId}`, { params: { ...params } })
  }

  static status(followUpId: number, body: any) {
    return this.api.patch(`${url}/status/${followUpId}`, body)
  }

  static noteDetail(followUpId: number, body: { note: string }) {
    return this.api.patch(`${url}/note/${followUpId}`, body)
  }

  static findUsers(params: any): Promise<any> {
    return this.api.get(`${url}/users`, { params: { ...params } })
  }

  static submitFollow(followUpId: number, body: any) {
    return this.api.patch(`${url}/followup/${followUpId}`, body)
  }

  static cancelFollow(followUpId: number, body: bodyCancelFollow) {
    return this.api.patch(`${url}/unfollow/${followUpId}`, body)
  }

  static findUseCourse(params: any, patientTreatmentCourseId: number): Promise<any> {
    return this.api.get(`${url}/use-course/${patientTreatmentCourseId}`, { params: { ...params } })
  }

  static finishCase(followUpId: number) {
    return this.api.patch(`${url}/finish-case/${followUpId}`)
  }

}
